<template>
  <Modal id="ChargeStationImagesDetail" width="60%" :open="visible" @cancel="visible = !visible" @ok="visible = !visible" :title="$t('chargeStationImages.name.detailTitle')" :zIndex="9999999900">
    <Descriptions >
      <DescriptionsItem :label="$t('chargeStationImages.field.id_ima')">{{data.idIma}}</DescriptionsItem>
      <DescriptionsItem :label="$t('chargeStationImages.field.id_cha_poi')">{{data.chargingStationChargeBoxId}}</DescriptionsItem>
      <DescriptionsItem :label="$t('chargeStationImages.field.url')">{{data.url}}</DescriptionsItem>
      <DescriptionsItem :label="$t('chargeStationImages.field.upload_time')">{{data.uploadTime}}</DescriptionsItem>
      <!-- <DescriptionsItem :label="$t('chargeStationImages.field.tenant_key')">{{data.tenantKey}}</DescriptionsItem> -->
  </Descriptions>
  </Modal>
</template>

<script>
import { Modal, Descriptions,DescriptionsItem } from "ant-design-vue";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons-vue";

export default {
  name: "ChargeStationImagesDetail",
  components: {
    Modal,
    LoadingOutlined,
    PlusOutlined,
    Descriptions,
    DescriptionsItem,
  },
  data() {
    return {
      selectList:{
      },
      data: {
      },
      visible: false,
    };
  },
  computed: {
  },
  methods: {
    async detailShow(obj) {
      this.data = JSON.parse(JSON.stringify(obj));
      this.visible = true;
    },
  },
}
</script>

<style lang="less">
</style>